import React from 'react';
import download from 'downloadjs';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from 'reactstrap';
import { withRouter } from 'react-router';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
// import Loader from './Loader';
import Styled from './StyledComponents';
import Asset from './Asset';
import {getQueryParams} from "./utils";

const checkError = (error = {}, field) => {
  return error && error[field] ? 'danger' : '';
};

const RenderError = ({ error = {}, field }) => (error && error[field] ? <FormFeedback>{error[field]}</FormFeedback> : null);

const Toast = ({ message }) => <div>{message}</div>;

const downloadFile = (fileUrl, filename) => {
  window.open(fileUrl, '_blank');
  // toast.info(<Toast message={`Start downloading ${filename}`} />);
  // const xhr = new XMLHttpRequest();
  // xhr.open('GET', fileUrl, true);
  // xhr.responseType = 'blob';
  // xhr.onload = () => {
  //   download(xhr.response, filename);
  //   toast.info(<Toast message={`${filename} download complete`} />);
  // };
  // xhr.send();
};

const CAPTCHA_KEY = '6LeLlq4ZAAAAAGrx4HzK2u90j2-00PZ7Z8OL1E5f';
const CAPTCHA_URL = `https://www.google.com/recaptcha/api.js?render=${CAPTCHA_KEY}`;


const Header = styled.header`
  padding: 15px;
  overflow: hidden;

  .Rooms {
    margin-right: 10px;

    &:first-child {
      margin-right: 0;
    }

    .fa {
      margin-right: 5px;
    }
  }
`;

const Main = styled.main`
  margin-top: 30px;

  ul {
    list-style: circle;
  }
`;


const SpaceBetween = styled(Styled.Flex) `
  justify-content: space-between;
  margin-bottom: 15px;
`;

const StyledItem = styled.div`
  img {
    width: 100%;
    height: 500px;
    margin: 0 auto;
  }
`;

const Status = styled.div`
  position: absolute;
  top: -7px;
  right: 0;
  padding: 5px;
  width: 150px;
  height: 40px;
  font-size: 16px;
  color: #fff !important;
  text-align: center;
  z-index: 9999;
  margin-right: 16px;
  border-radius: 5px;
  ${({ status }) =>
    status === "Let Agreed" || status === "Sold STC"
        ? `
    background: red;
  `
        : status === "Under Offer"
        ? `background: orange;`
        : `background: none;`}
  ${({ status }) => status === "Available" && `display: none;`}
  @media (max-width: 575px) {
    width: 100px;
  }
`;

const status = {
  1: 'Available',
  3: 'Let Agreed',
  5: 'Sold STC',
  4: 'Under Offer'
}

class PropertyDetails extends React.Component {
  state = {
    property: {},
    loading: true,
    modal: false,
    contact: {
      property_id: this.props.match.params.id
    },
  }
  loadCaptcha = () => {
    const script = document.createElement("script");
    script.src = CAPTCHA_URL;
    document.body.appendChild(script);
  }
  componentDidMount() {
    this.loadCaptcha();
    fetch(`https://property-api.juvo.io/info${getQueryParams()}&id=${this.props.match.params.id}`)
      .then(response => response.json()
        .then(({ property }) => {
          const images = [...property.assets].filter(asset => asset.type_id === 1);
          const assets = [...property.assets].filter(asset => asset.type_id !== 1);
          const features = Object.keys(property).filter(key => (key.includes('feature_') && property[key]));
          console.log(features);
          this.setState({ property, images, assets, loading: false, features });
        })
        .catch(() => this.setState({ loading: false })))
      .catch(() => this.setState({ loading: false }));

    // fetch(`https://property-api.juvo.io/options${getQueryParams()}`)
    //   .then(response => response.json()
    //     .then(({ status: propertyStatuses, type: propertyTypes }) => this.setState({ propertyStatuses, propertyTypes })));
  }
  handleBackClick = () => {
    this.props.history.goBack();
  }
  handleContactChange = (e) => {
    const contact = { ...this.state.contact };
    contact[e.target.name] = e.target.value;
    this.setState({ contact });
  }

  handleContactSubmit = (e) => {
    e.preventDefault();
    window.grecaptcha.execute(CAPTCHA_KEY, { action: "homepage" })
        .then(token => {
          let contact = {...this.state.contact};
          contact.recaptcha_response = token

          this.setState({ enquiring: true }, () => {
            fetch(`https://property-api.juvo.io/contact${getQueryParams()}`, { headers: { "Content-Type": "application/json" }, method: 'post', body: JSON.stringify(contact) })
                .then((res) => {
                  this.setState({ enquiring: false });
                  res.json()
                      .then((data) => {
                        if (data.status !== 'error') {
                          this.setState({ modal: false, error: null });
                          toast.info(<Toast message="Enquire send!" />);
                        } else {
                          this.setState({ error: data.error });
                          toast.error(<Toast message={data.message} />);
                        }
                      })
                      .catch((error) => {
                        console.log(error);
                        toast.error(<Toast message={error.message} />);
                      });
                })
                .catch((error) => {
                  console.log(error);
                  toast.error(<Toast message={error.message} />);
                  this.setState({ enquiring: false });
                });
          });
        })
  }
  toogleModal = () => {
    this.setState({ modal: !this.state.modal, error: this.state.modal ? null : this.state.error })
  }
  render() {
    const { property, images = [], assets = [], features = [], contact, enquiring } = this.state;
    const slider = {
      dots: true,
      // infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      arrows: true,
      // centerMode: true,
      // autoplay: true,
      autoplaySpeed: 2000,
      // nextArrow: <SampleNextArrow />,
      // prevArrow: <SamplePrevArrow />
    };
    return (<section>
      <Header>
        <Container>
          <SpaceBetween>
            <Button color="info" onClick={this.handleBackClick}>Back To Listing</Button>
            <Button color="success" onClick={this.toogleModal}>Enquire</Button>
          </SpaceBetween>
          <Row>
            <Col xs={12} sm={4}>
              <h4 dangerouslySetInnerHTML={{__html: property.price_display + ' ' + property.price_label}} />
              <Status status={status[property.status_id]}>{status[property.status_id]}</Status>
            </Col>
            <Col xs={12} sm={5}>
              <h4>{property.advertise_address}</h4>
            </Col>
            <Col xs={12} sm={3}>
              <span className="pull-right Rooms">
                <i className="fa fa-bath" />
                {property.bathrooms || 'N/A'}
              </span>
              <span className="pull-right Rooms">
                <i className="fa fa-bed" />
                {property.bedrooms || 'N/A'}
              </span>
            </Col>
          </Row>
        </Container>
      </Header>
      {images.length > 0 ? (
        <Slider {...slider}>
          {images.map(image => (
            <StyledItem key={image.id}>
              <img src={image.url} alt={image.filename} />
            </StyledItem>
            ))}
        </Slider>
        ) : null}
      <Main>
        <Container>
          <Row>
            <Col xs={12} sm={8}>
              <h4>Features:</h4>
              <ul>
                {features.map(feature => (
                  <li key={`${Date.now()}${Math.random()}`}>{property[feature]}</li>
                  ))}
              </ul>
              <h4>Description:</h4>
              <div dangerouslySetInnerHTML={{ __html: property.description }} />
            </Col>
            <Col xs={12} sm={4}>
              <h4>Assets: </h4>
              {assets.map(asset => (
                <Asset key={asset.id} asset={asset} downloadFile={downloadFile} />
                ))}
            </Col>
          </Row>
        </Container>
      </Main>
      <ToastContainer />
      <Modal isOpen={this.state.modal} toggle={this.toogleModal}>
        <ModalHeader toggle={this.toogleModal}>
            Property Enquiry
          </ModalHeader>
        <ModalBody>
          <Form onSubmit={this.handleContactSubmit}>
            <input hidden name="property_id" value={property.id || 0} onChange={this.handleContactChange} />
            <FormGroup row color={checkError(this.state.error, 'title')}>
              <Label for="title" sm={3}>Title</Label>
              <Col sm={9}>
                <Input type="select" name="title" id="title" value={contact.title || ''} onChange={this.handleContactChange}>
                  <option value="" disabled>Title</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Miss">Miss</option>
                  <option value="Dr">Dr</option>
                </Input>
                <RenderError error={this.state.error} field="title" />
              </Col>
            </FormGroup>
            <FormGroup row color={checkError(this.state.error, 'forename')}>
              <Label for="forename" sm={3}>Forename</Label>
              <Col sm={9}>
                <Input name="forename" id="forename" value={contact.forename || ''} onChange={this.handleContactChange} />
                <RenderError error={this.state.error} field="forename" />
              </Col>
            </FormGroup>
            <FormGroup row color={checkError(this.state.error, 'surname')}>
              <Label for="surname" sm={3}>Surname</Label>
              <Col sm={9}>
                <Input name="surname" id="surname" value={contact.surname || ''} onChange={this.handleContactChange} />
                <RenderError error={this.state.error} field="surname" />
              </Col>
            </FormGroup>
            <FormGroup row color={checkError(this.state.error, 'email')}>
              <Label for="email" sm={3}>Email</Label>
              <Col sm={9}>
                <Input type="email" name="email" id="email" value={contact.email || ''} onChange={this.handleContactChange} />
                <RenderError error={this.state.error} field="email" />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="phone" sm={3}>Phone</Label>
              <Col sm={9}>
                <Input type="tel" name="phone" id="phone" value={contact.phone || ''} onChange={this.handleContactChange} />
              </Col>
            </FormGroup>
            <FormGroup row color={checkError(this.state.error, 'message')}>
              <Label for="message" sm={3}>Message</Label>
              <Col sm={9}>
                <Input type="textarea" name="message" id="message" value={contact.message || ''} onChange={this.handleContactChange} />
                <RenderError error={this.state.error} field="message" />
              </Col>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.handleContactSubmit} disabled={enquiring}>Enquire</Button>{' '}
          <Button color="secondary" onClick={this.toogleModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </section>);
  }
}

export default withRouter(PropertyDetails);



// WEBPACK FOOTER //
// ./src/components/PropertyDetails.js